<template>
    <div class="vx-row">
        <vx-card title="" class="mb-4">
            <div class="w-full flex flex-no-wrap">
                <div class="vx-col sm:w-1/5 w-full p-4">
                    <span>Upload file</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full p-2">
                    <div class="vx-row">
                        <div class="w-1/3">
                            <custom-upload id="fil-bulk-device-registration" title="File" :file-name="document.file_name"
                                           :on-change-callback="handleFileUpload"
                                           :on-delete-callback="handleDelete"/>
                        </div>
                        <div class="flex flex-no-wrap w-2/4 self-center">
                            <div class="w-1/4 self-center">
                                <vx-tooltip text="Download Sample" position="top">
                                    <vs-button id="btn-download-sample" class="mb-4 md:mb-0" icon-pack="feather"
                                               icon="icon-download" @click="downloadExcel"></vs-button>
                                </vx-tooltip>
                            </div>
                            <div class="w-1/4">&nbsp;</div>
                        </div>
                    </div>
                    <div class="w-full self-center">
                        Please download sample excel and follow our template.<br/>
                    </div>
                </div>
            </div>
        </vx-card>
        <vx-card>
            <div class="w-full text-right">
                <vs-button id="btn-cancel" color="warning" @click="backPage">Cancel</vs-button>
                <vs-button id="btn-submit" class="ml-4" @click.prevent="submitForm">Submit</vs-button>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import CustomUpload from "@/components/upload/custom-upload"
    import DeviceAPI from "@/network/api/DeviceAPI"
    import Excel from "exceljs/modern.browser"
    import DeviceTypeAPI from "@/network/api/DeviceTypeAPI"
    import {saveAs} from 'file-saver'

    export default {
        name: "DeviceImportExcel",
        components: {
            CustomUpload
        },
        data() {
            return {
                deviceTypes: [],
                document: {
                    name: "Devices excel",
                    file_name: "",
                    url: ""
                },
                file: null,
                fileInfo: {
                    name: "",
                    size: "",
                    type: "",
                },
            }
        },
        methods: {
            backPage() {
                this.$router.go(-1)
            },
            validateform() {
                return (!this.errors.any() &&
                    this.device_type_id !== "" &&
                    this.serial_number !== ""
                )
            },
            submitForm() {
                if (this.file === null) {
                    this.$vs.notify({
                        title: "Warning",
                        text: "Please select file!",
                        color: "warning",
                        position: "top-right"
                    })
                } else {
                    this.$vs.loading({
                        type: "radius"
                    })

                    DeviceAPI.ImportFromExcel(this.file)
                        .then(() => {
                            this.$store.dispatch('createAuditTrail', {
                                user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                                session_id: parseInt(localStorage.getItem('sessID')),
                                user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                                menu:      "Device Registration",
                                activity: "Bulk Registration",
                                data_after: {
                                    file_info: {
                                        name: this.fileInfo.name,
                                        size: this.fileInfo.size,
                                        type: this.fileInfo.type,
                                    }
                                }
                            })

                            this.$vs.notify({
                                title: "success",
                                text: "Bulk success",
                                color: "success",
                                position: "top-right"
                            })   
                            this.$vs.loading.close()
                            this.backPage()
                        }, error => {
                            this.$vs.loading.close()
                            this.$vs.notify(error.response.data.notify)
                        })
                }
            },
            handleFileUpload(file) {
                let temp = file
                this.fileInfo = {
                    name: JSON.stringify(temp.name),
                    size: JSON.stringify(parseInt(temp.size/1000)) +"KB",
                    type: JSON.stringify(temp.type)
                }
                let payload = {
                    file: file
                }

                this.file = payload
            },
            handleDelete(file, title) {
                if (title === this.document.name) {
                    this.document.file_name = ""
                    this.document.url = ""
                }

                this.file = null
            },
            downloadExcel() {
                let workbook = new Excel.Workbook()
                workbook.creator = JSON.parse(localStorage.getItem("userInfo")).displayName
                workbook.lastModifiedBy = JSON.parse(localStorage.getItem("userInfo")).displayName
                workbook.created = new Date()
                workbook.modified = new Date()
                workbook.lastPrinted = new Date()

// Set workbook dates to 1904 date system
                workbook.properties.date1904 = true

                let sheet = workbook.addWorksheet('Sheet1', {properties: {tabColor: {argb: 'FFC0000'}}})
                let deviceTypeSheet = workbook.addWorksheet('Device Types')

                //write device types
                deviceTypeSheet.getColumn('B').width = 20
                deviceTypeSheet.mergeCells('A1:B1')
                deviceTypeSheet.getCell('A1').value = "List Device Type available to use"
                deviceTypeSheet.getCell('A3').value = "No"
                deviceTypeSheet.getCell('B3').value = "Device Type"
                for (let i = 0; i<this.deviceTypes.length; i++){
                    deviceTypeSheet.getCell('A'+(i+4)).value = i+1
                    deviceTypeSheet.getCell('B'+(i+4)).value = this.deviceTypes[i].name
                }

                sheet.getColumn('B').width = 20
                sheet.getColumn('C').width = 20

                //write header
                sheet.mergeCells('A1:C1')
                sheet.getCell('A1').value = 'Devices'
                sheet.getCell('A1').alignment = { horizontal:'center'}

                sheet.getCell('A3').value = 'No'
                sheet.getCell('B3').value ='Serial Number'
                sheet.getCell('C3').value ='Device Type'

                //write record
                sheet.getCell('A4').value = 1
                sheet.getCell('B4').value = '123456QWERT'
                sheet.getCell('C4').value = this.deviceTypes[0].name || 'Centem'

                workbook.xlsx.writeBuffer().then((buf) => {
                    saveAs(new Blob([buf]), `sample device.xlsx`)
                    // other stuffs
                })
            }
        },
        mounted() {
            DeviceTypeAPI.ListDeviceTypeForOptions()
                .then(result => {
                    this.deviceTypes = result.data
                })
        },
    }
</script>

<style scoped>
</style>